import React from 'react';
import {Form} from "react-bootstrap";
import PropTypes from 'prop-types';
import {PostFile} from "./request";
import {faCheck, faSpinner, faTimes} from "@fortawesome/pro-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ReactDOM from "react-dom";
import bsCustomFileInput from "bs-custom-file-input";
import {toast} from "react-toastify";

const MyFile = React.forwardRef((props, ref) => {
    async function SendFile(elm) {
        const file = elm.target.files[0];

        if (props.maxSizeMB && file.size > props.maxSizeMB * 1024 * 1024) {
            alert(`Le fichier dépasse la taille maximale de ${props.maxSizeMB} Mo !`);
            elm.target.value = "";
            elm.target.nextElementSibling.textContent = "";
            return;
        }

        let div;
        let find = elm.target.name === "ID" ? elm.target.closest('.actions') : fileGroup;

        if (ReactDOM.findDOMNode(find).getElementsByClassName('file-loading').length > 0) {
            div = ReactDOM.findDOMNode(find).getElementsByClassName('file-loading')[0];
            ReactDOM.render(<FontAwesomeIcon icon={faSpinner} className={"fa-pulse"}/>, ReactDOM.findDOMNode(div));
        } else {
            div = document.createElement('div');
            div.classList.add('file-loading');

            if (elm.target.name === "ID") {
                div.style['position'] = 'inherit';
                ReactDOM.findDOMNode(find).parentNode.getElementsByClassName('actions')[0].append(div);
            } else {
                ReactDOM.findDOMNode(find).getElementsByClassName('custom-file')[0].append(div);
            }

            ReactDOM.render(<FontAwesomeIcon icon={faSpinner} className={"fa-pulse"}/>, ReactDOM.findDOMNode(div));
        }

        const typesList = props.accept
            .split(',')
            .map(t => t.includes('/') ? t.split('/')[1] : t)
            .join(', ');

        if (props.accept !== '*/*') {
            var MIMEtype = new RegExp(props.accept.replaceAll(',', '|').replaceAll('*', '[^\\/,]+'));

            if (!MIMEtype.test(file.type)) {
                ReactDOM.render(<FontAwesomeIcon icon={faTimes} className={"text-danger"}/>, ReactDOM.findDOMNode(div));
                alert(`Le fichier doit être de type : ${typesList}.`);

                elm.target.value = "";
                elm.target.nextElementSibling.textContent = "";
                return;
            }
        }

        const {body} = await PostFile(file);

        if (props.onChange) {
            props.onChange(body.DocumentID, file.name);
        }

        ReactDOM.render(<FontAwesomeIcon icon={faCheck} className={"text-success"}/>, ReactDOM.findDOMNode(div));
    }

    let fileGroup;

    bsCustomFileInput.init();

    return (
        <Form.Group ref={r => fileGroup = r}>
            <Form.Label className={props.required && "required"}>{props.label}</Form.Label>
            <Form.File
                name={props.name}
                label={props.filename}
                custom
                required={props.required}
                onChange={SendFile.bind(this)}
                accept={props.accept}
                ref={props.inputRef}
            />
        </Form.Group>
    );
});

MyFile.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    required: PropTypes.bool,
    filename: PropTypes.string,
    accept: PropTypes.string,
    maxSizeMB: PropTypes.number,
};

MyFile.defaultProps = {
    required: false,
    filename: "",
    accept: "*/*",
    maxSizeMB: null
};

export default MyFile;